// Screen 1 · Sign-in — calm, low-friction. Errors are non-blaming (Design Brief).

import { api } from "../api";
import { setMe, type Me } from "../state";
import { navigate } from "../router";
import { isNetworkError } from "../offline";

const OFFLINE_MSG = "You're offline. You'll be able to sign in once you're back online.";

export function renderSignin(app: HTMLElement): void {
  app.innerHTML = `
    <h1>Welcome back.</h1>
    <p class="hint">Sign in to plan tomorrow's lesson.</p>
    <form id="signin" novalidate>
      <label for="email">Email</label>
      <input id="email" type="email" autocomplete="username" required />
      <label for="passcode">Passcode</label>
      <input id="passcode" type="password" autocomplete="current-password" required />
      <div id="err" class="error" hidden></div>
      <div style="height:16px"></div>
      <button class="btn" type="submit">Sign in</button>
    </form>`;

  const err = app.querySelector<HTMLElement>("#err")!;

  // Cold-reload while offline lands here (the session can't be confirmed offline). Say so
  // calmly up front, rather than letting a submit fail with a raw network error.
  if (!navigator.onLine) {
    err.textContent = OFFLINE_MSG;
    err.hidden = false;
  }

  app.querySelector<HTMLFormElement>("#signin")!.addEventListener("submit", async (e) => {
    e.preventDefault();
    const email = app.querySelector<HTMLInputElement>("#email")!.value.trim();
    const passcode = app.querySelector<HTMLInputElement>("#passcode")!.value;
    err.hidden = true;
    try {
      const m = await api<Me>("/api/auth/signin", {
        method: "POST",
        body: JSON.stringify({ email, passcode }),
      });
      setMe(m);
      navigate("/");
    } catch (ex) {
      err.textContent = isNetworkError(ex) ? OFFLINE_MSG : (ex as Error).message;
      err.hidden = false;
    }
  });
}
